const formatCurrency = (a, currency) => {
  let cur = '€';
  if (currency === 'usd') {
    cur = '$';
  }
  return `${a.toFixed(2)}${cur}`;
};

export default formatCurrency;
